import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type PricingExitDiscountPopupStoreType = {
    // from api
    showDiscountPopUp: boolean;
    hasSeen: boolean;
    isShow: boolean;
    setIsShow: (val: boolean) => void;
    setHasSeen: (val: boolean) => void;
    setShowDiscountPopUp: (val: boolean) => void;
    clear: () => void;
}


// with persist
export const usePricingExitDiscountPopupState = create(
  persist<PricingExitDiscountPopupStoreType>(
    (set) => ({
        hasSeen: false,
        showDiscountPopUp: false,
        isShow: false,
        setHasSeen: (val) => set({ hasSeen: val }),
        setIsShow: (val) => set({ isShow: val }),
        setShowDiscountPopUp: (val) => set({ showDiscountPopUp: val }),
        clear: () => set({ hasSeen: false, showDiscountPopUp: false, isShow: false }),
    }),
    {
      name: "discountPopup",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);